import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { MouseEvent } from 'react'
import css from './CountButton.module.scss'

type Props = {
  count: number
  onClear: () => void
  onClick: () => void
  title: string
}

export const CountButton = observer(({ count, onClear, onClick, title }: Props) => {
  const onClickClear = useLatestCallback((event: MouseEvent) => {
    event.stopPropagation()
    onClear()
  })

  return <Button className={clsx(!count && css.empty)} pad={[0, 8]} primary={!!count} action={onClick}>
    <Typo size={13} one upper>
      {title}
      {count > 0 && ` (${count})`}
    </Typo>
    {count > 0 && <Space className={css.icon} center onClick={onClickClear}>
      <Icon size={16} name="close" />
    </Space>}
  </Button>
})
